var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3334 13.9997C25.3334 20.2589 20.2593 25.333 14.0001 25.333C7.74085 25.333 2.66675 20.2589 2.66675 13.9997C2.66675 7.74049 7.74085 2.66638 14.0001 2.66638C20.2593 2.66638 25.3334 7.74049 25.3334 13.9997ZM27.3334 13.9997C27.3334 21.3635 21.3639 27.333 14.0001 27.333C6.63628 27.333 0.666748 21.3635 0.666748 13.9997C0.666748 6.63592 6.63628 0.666382 14.0001 0.666382C21.3639 0.666382 27.3334 6.63592 27.3334 13.9997ZM13.9995 8.51448C14.4705 8.51448 14.8597 8.86444 14.9213 9.31848L14.9298 9.44471V13.0578H18.5478C19.0615 13.0578 19.478 13.4743 19.478 13.9881C19.478 14.459 19.128 14.8482 18.674 14.9098L18.5478 14.9183H14.9298V18.5317C14.9298 19.0454 14.5133 19.4619 13.9995 19.4619C13.5286 19.4619 13.1394 19.1119 13.0778 18.6579L13.0693 18.5317V14.9183H9.45217C8.93841 14.9183 8.52193 14.5018 8.52193 13.9881C8.52193 13.5171 8.87189 13.1279 9.32594 13.0663L9.45217 13.0578H13.0693V9.44471C13.0693 8.93096 13.4858 8.51448 13.9995 8.51448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.11f720995202b28675d0426464fe9f2f.svg";
export { ForwardRef as ReactComponent };